/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type AutomaticEmailStepSubjectMode = typeof AutomaticEmailStepSubjectMode[keyof typeof AutomaticEmailStepSubjectMode];


export const AutomaticEmailStepSubjectMode = {
  static: 'static',
  ai_generated: 'ai_generated',
} as const;
